import { useState, useEffect } from "react";
import "./Dashboard.css";

import CarIconImage from "./car.png";
import BikeIconImage from "./bike.png";
import RevenueLogo from "./fiveone.png";
import TargetLogo from "./fivetwo.png";
import TargetBgImage from "./target.png";

// ── DATA ─────────────────────────────────────────────────────────────────────

const CHART_DATA = {
  daily:   [ {label:"Mon",val:55},{label:"Tue",val:72},{label:"Wed",val:80},{label:"Thu",val:42},{label:"Fri",val:92},{label:"Sat",val:55},{label:"Sun",val:62} ],
  weekly:  [ {label:"W1",val:62},{label:"W2",val:75},{label:"W3",val:55},{label:"W4",val:80},{label:"W5",val:48},{label:"W6",val:90},{label:"W7",val:70} ],
  monthly: [ {label:"Jan",val:60},{label:"Feb",val:55},{label:"Mar",val:70},{label:"Apr",val:65},{label:"May",val:80},{label:"Jun",val:92},{label:"Jul",val:50} ],
};
 
const ACTIVITY = [
  { type:"in",  title:"Check-In Processed",  sub:"Plate: TN68AH8842",        time:"14:22 PM" },
  { type:"pay", title:"Payment Processed",    sub:"Payment #99401 · 24.50",   time:"14:18 PM" },
  { type:"out", title:"Check-Out Processed",  sub:"Plate: TN68AH8982",        time:"14:05 PM" },
  { type:"in",  title:"Check-In Processed",   sub:"Plate: Plate: TN68AH8842", time:"14:22 PM" },
];

const FLOORS = [
  { name:"Ground Level",          label:"GROUND LEVEL",           count:42, total:50,  pct:84, color:"#EF4444" },
  { name:"Level 1 · First Floor", label:"LEVEL 1 - FIRST FLOOR",  count:12, total:30,  pct:40, color:"#6c63ff" },
  { name:"Level 2 · Second Floor",label:"LEVEL 2 - SECOND FLOOR", count:88, total:100, pct:88, color:"#a78bfa" },
  { name:"3rd Floor · Car Parking",label:"3RD FLOOR - CAR PARKING",count:5, total:40,  pct:12, color:"#D1D5DB" },
];

// ── SIDEBAR ───────────────────────────────────────────────────────────────────

function Sidebar({ setPage }) {
  const [active, setActive] = useState("dashboard");
  const items = [

    { id:"dashboard", icon:(<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 6V0H18V6H10ZM0 10V0H8V10H0ZM10 18V8H18V18H10ZM0 18V12H8V18H0ZM2 8H6V2H2V8ZM12 16H16V10H12V16ZM12 4H16V2H12V4ZM2 16H6V14H2V16Z" fill="white"/>
</svg>
), label:"Dashboard" },

    { id:"vehicles",  icon:(<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 14V15C3 15.2833 2.90417 15.5208 2.7125 15.7125C2.52083 15.9042 2.28333 16 2 16H1C0.716667 16 0.479167 15.9042 0.2875 15.7125C0.0958333 15.5208 0 15.2833 0 15V7L2.1 1C2.2 0.7 2.37917 0.458333 2.6375 0.275C2.89583 0.0916667 3.18333 0 3.5 0H14.5C14.8167 0 15.1042 0.0916667 15.3625 0.275C15.6208 0.458333 15.8 0.7 15.9 1L18 7V15C18 15.2833 17.9042 15.5208 17.7125 15.7125C17.5208 15.9042 17.2833 16 17 16H16C15.7167 16 15.4792 15.9042 15.2875 15.7125C15.0958 15.5208 15 15.2833 15 15V14H3ZM2.8 5H15.2L14.15 2H3.85L2.8 5ZM2 7V12V7ZM4.5 11C4.91667 11 5.27083 10.8542 5.5625 10.5625C5.85417 10.2708 6 9.91667 6 9.5C6 9.08333 5.85417 8.72917 5.5625 8.4375C5.27083 8.14583 4.91667 8 4.5 8C4.08333 8 3.72917 8.14583 3.4375 8.4375C3.14583 8.72917 3 9.08333 3 9.5C3 9.91667 3.14583 10.2708 3.4375 10.5625C3.72917 10.8542 4.08333 11 4.5 11ZM13.5 11C13.9167 11 14.2708 10.8542 14.5625 10.5625C14.8542 10.2708 15 9.91667 15 9.5C15 9.08333 14.8542 8.72917 14.5625 8.4375C14.2708 8.14583 13.9167 8 13.5 8C13.0833 8 12.7292 8.14583 12.4375 8.4375C12.1458 8.72917 12 9.08333 12 9.5C12 9.91667 12.1458 10.2708 12.4375 10.5625C12.7292 10.8542 13.0833 11 13.5 11ZM2 12H16V7H2V12Z" fill="white"/>
</svg>
),        label:"Vehicles"  },

    { id:"checkin",   icon:(<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.55 17.1V15.2H15.2V1.9H8.55V0H15.2C15.7225 0 16.1698 0.186042 16.5419 0.558125C16.914 0.930208 17.1 1.3775 17.1 1.9V15.2C17.1 15.7225 16.914 16.1698 16.5419 16.5419C16.1698 16.914 15.7225 17.1 15.2 17.1H8.55ZM6.65 13.3L5.34375 11.9225L7.76625 9.5H0V7.6H7.76625L5.34375 5.1775L6.65 3.8L11.4 8.55L6.65 13.3Z" fill="white"/>
</svg>
),       label:"Check-In"  },

    { id:"checkout",  icon:(<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H9V2H2V16H9V18H2ZM13 14L11.625 12.55L14.175 10H6V8H14.175L11.625 5.45L13 4L18 9L13 14Z" fill="white"/>
</svg>
),      label:"Check-Out" },

    { id:"analytics", icon:(<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 14H6V9H4V14ZM12 14H14V4H12V14ZM8 14H10V11H8V14ZM8 9H10V7H8V9ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16ZM2 2V16V2Z" fill="white"/>
</svg>
),   label:"Analytics" },

    { id:"settings",  icon:(<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.3 20L6.9 16.8C6.68333 16.7167 6.47917 16.6167 6.2875 16.5C6.09583 16.3833 5.90833 16.2583 5.725 16.125L2.75 17.375L0 12.625L2.575 10.675C2.55833 10.5583 2.55 10.4458 2.55 10.3375C2.55 10.2292 2.55 10.1167 2.55 10C2.55 9.88333 2.55 9.77083 2.55 9.6625C2.55 9.55417 2.55833 9.44167 2.575 9.325L0 7.375L2.75 2.625L5.725 3.875C5.90833 3.74167 6.1 3.61667 6.3 3.5C6.5 3.38333 6.7 3.28333 6.9 3.2L7.3 0H12.8L13.2 3.2C13.4167 3.28333 13.6208 3.38333 13.8125 3.5C14.0042 3.61667 14.1917 3.74167 14.375 3.875L17.35 2.625L20.1 7.375L17.525 9.325C17.5417 9.44167 17.55 9.55417 17.55 9.6625C17.55 9.77083 17.55 9.88333 17.55 10C17.55 10.1167 17.55 10.2292 17.55 10.3375C17.55 10.4458 17.5333 10.5583 17.5 10.675L20.075 12.625L17.325 17.375L14.375 16.125C14.1917 16.2583 14 16.3833 13.8 16.5C13.6 16.6167 13.4 16.7167 13.2 16.8L12.8 20H7.3ZM9.05 18H11.025L11.375 15.35C11.8917 15.2167 12.3708 15.0208 12.8125 14.7625C13.2542 14.5042 13.6583 14.1917 14.025 13.825L16.5 14.85L17.475 13.15L15.325 11.525C15.4083 11.2917 15.4667 11.0458 15.5 10.7875C15.5333 10.5292 15.55 10.2667 15.55 10C15.55 9.73333 15.5333 9.47083 15.5 9.2125C15.4667 8.95417 15.4083 8.70833 15.325 8.475L17.475 6.85L16.5 5.15L14.025 6.2C13.6583 5.81667 13.2542 5.49583 12.8125 5.2375C12.3708 4.97917 11.8917 4.78333 11.375 4.65L11.05 2H9.075L8.725 4.65C8.20833 4.78333 7.72917 4.97917 7.2875 5.2375C6.84583 5.49583 6.44167 5.80833 6.075 6.175L3.6 5.15L2.625 6.85L4.775 8.45C4.69167 8.7 4.63333 8.95 4.6 9.2C4.56667 9.45 4.55 9.71667 4.55 10C4.55 10.2667 4.56667 10.525 4.6 10.775C4.63333 11.025 4.69167 11.275 4.775 11.525L2.625 13.15L3.6 14.85L6.075 13.8C6.44167 14.1833 6.84583 14.5042 7.2875 14.7625C7.72917 15.0208 8.20833 15.2167 8.725 15.35L9.05 18ZM10.1 13.5C11.0667 13.5 11.8917 13.1583 12.575 12.475C13.2583 11.7917 13.6 10.9667 13.6 10C13.6 9.03333 13.2583 8.20833 12.575 7.525C11.8917 6.84167 11.0667 6.5 10.1 6.5C9.11667 6.5 8.2875 6.84167 7.6125 7.525C6.9375 8.20833 6.6 9.03333 6.6 10C6.6 10.9667 6.9375 11.7917 7.6125 12.475C8.2875 13.1583 9.11667 13.5 10.1 13.5Z" fill="white"/>
</svg>
),    label:"Settings"  },
  ];
  return (
    <aside className="sidebar">
      <nav>
        {items.map(item => (
  <div
    key={item.id}
    className={`menu-item${active===item.id?" active":""}`}
    onClick={() => {

  if (item.id === "dashboard") {
    setActive("dashboard");
  }

  if (item.id === "vehicles") {
    setActive("vehicles");
    setPage("vehicle");
  }

  if (item.id === "checkin") {
    setActive("checkin");
    setPage("checkin");
  }

  if (item.id === "checkout") {
    setActive("dashboard");   // Keep Dashboard highlighted
    return;                   // Don't open Checkout page
  }

  if (item.id === "analytics") {
    setActive("analytics");
    setPage("analytics");
  }

  if (item.id === "settings") {
    setActive("settings");
    setPage("settings");
  }

}}
  >
            {item.icon}<span>{item.label}</span>
          </div>
        ))}
      </nav>
    </aside>
  );
}

// ── TOPBAR ────────────────────────────────────────────────────────────────────

function Topbar() {
  return (
    <div className="topbar">
      <div>
        <div className="page-title">Occupancy Overview</div>
        <div className="page-sub">Real-time status of Terminal 4 Parking Complex</div>
      </div>
      <div className="topbar-actions">
        <div className="search-bar">
          <svg width="16" height="16" viewBox="0 0 18 18" fill="none">
            <path d="M16.6 18L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.14583 12.3708 1.8875 11.1125C0.629167 9.85417 0 8.31667 0 6.5C0 4.68333 0.629167 3.14583 1.8875 1.8875C3.14583 0.629167 4.68333 0 6.5 0C8.31667 0 9.85417 0.629167 11.1125 1.8875C12.3708 3.14583 13 4.68333 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L18 16.6L16.6 18ZM6.5 11C7.75 11 8.8125 10.5625 9.6875 9.6875C10.5625 8.8125 11 7.75 11 6.5C11 5.25 10.5625 4.1875 9.6875 3.3125C8.8125 2.4375 7.75 2 6.5 2C5.25 2 4.1875 2.4375 3.3125 3.3125C2.4375 4.1875 2 5.25 2 6.5C2 7.75 2.4375 8.8125 3.3125 9.6875C4.1875 10.5625 5.25 11 6.5 11Z" fill="#7C709C"/>
          </svg>
          Search vehicle or zone…
        </div>
        <div className="notif-btn">
          <svg width="16" height="20" viewBox="0 0 16 20" fill="none">
            <path d="M0 17V15H2V8C2 6.61667 2.41667 5.3875 3.25 4.3125C4.08333 3.2375 5.16667 2.53333 6.5 2.2V1.5C6.5 1.08333 6.64583 0.729167 6.9375 0.4375C7.22917 0.145833 7.58333 0 8 0C8.41667 0 8.77083 0.145833 9.0625 0.4375C9.35417 0.729167 9.5 1.08333 9.5 1.5V2.2C10.8333 2.53333 11.9167 3.2375 12.75 4.3125C13.5833 5.3875 14 6.61667 14 8V15H16V17H0ZM8 20C7.45 20 6.97917 19.8042 6.5875 19.4125C6.19583 19.0208 6 18.55 6 18H10C10 18.55 9.80417 19.0208 9.4125 19.4125C9.02083 19.8042 8.55 20 8 20ZM4 15H12V8C12 6.9 11.6083 5.95833 10.825 5.175C10.0417 4.39167 9.1 4 8 4C6.9 4 5.95833 4.39167 5.175 5.175C4.39167 5.95833 4 6.9 4 8V15Z" fill="#33284F"/>
          </svg>
          <div className="notif-dot" />
        </div>
        <button className="quick-entry-btn">+ Quick Entry</button>
      </div>
    </div>
  );
}

// ── DAILY STATS ───────────────────────────────────────────────────────────────

function MiniBar({ pct }) {
  return (
    <div className="mini-bar-track">
      <div className="mini-bar-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}

function GridIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect x="2"  y="2"  width="12" height="12" rx="2" fill="rgba(255,255,255,0.35)"/>
      <rect x="18" y="2"  width="12" height="12" rx="2" fill="rgba(255,255,255,0.35)"/>
      <rect x="2"  y="18" width="12" height="12" rx="2" fill="rgba(255,255,255,0.35)"/>
      <rect x="18" y="18" width="12" height="12" rx="2" fill="rgba(255,255,255,0.35)"/>
    </svg>
  );
}

function DailyStats() {
  return (
    <section className="daily-stats-section">
      <div className="section-header">
        <h2 className="section-title">Daily Stats</h2>
        <div className="floor-select">
          First Floor
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#33284F" strokeWidth="2.5"><path d="m6 9 6 6 6-6"/></svg>
        </div>
      </div>
      <div className="stats-grid">
        <div className="stat-card accent-card">
          <div className="stat-label">TOTAL CAPACITY</div>
          <div className="stat-value accent-value">160</div>
          <div className="stat-sub accent-sub">
            <svg width="10" height="13" viewBox="0 0 10 13" fill="none">
              <path d="M5 6.5C5.32083 6.5 5.59549 6.38576 5.82396 6.15729C6.05243 5.92882 6.16667 5.65417 6.16667 5.33333C6.16667 5.0125 6.05243 4.73785 5.82396 4.50938C5.59549 4.28090 5.32083 4.16667 5 4.16667C4.67917 4.16667 4.40451 4.28090 4.17604 4.50938C3.94757 4.73785 3.83333 5.0125 3.83333 5.33333C3.83333 5.65417 3.94757 5.92882 4.17604 6.15729C4.40451 6.38576 4.67917 6.5 5 6.5ZM5 11.1208C6.18611 10.0319 7.06597 9.04271 7.63958 8.15312C8.21319 7.26354 8.5 6.47361 8.5 5.78333C8.5 4.72361 8.16215 3.8559 7.48646 3.18021C6.81076 2.50451 5.98194 2.16667 5 2.16667C4.01806 2.16667 3.18924 2.50451 2.51354 3.18021C1.83785 3.8559 1.5 4.72361 1.5 5.78333C1.5 6.47361 1.78681 7.26354 2.36042 8.15312C2.93403 9.04271 3.81389 10.0319 5 11.1208ZM5 12.6667C3.43472 11.3347 2.26563 10.0976 1.49271 8.95521C0.719792 7.81285 0.333333 6.75556 0.333333 5.78333C0.333333 4.325 0.802431 3.16319 1.74063 2.29792C2.67882 1.43264 3.76528 1 5 1C6.23472 1 7.32118 1.43264 8.25938 2.29792C9.19757 3.16319 9.66667 4.325 9.66667 5.78333C9.66667 6.75556 9.28021 7.81285 8.50729 8.95521C7.73438 10.0976 6.56528 11.3347 5 12.6667Z" fill="rgba(255,255,255,0.85)"/>
            </svg>
            Floor 1
          </div>
          <div className="accent-grid-icon"><GridIcon /></div>
        </div>

        <div className="stat-card">
          <div className="sc-top-row">
            <div className="stat-label">TOTAL AVAILABLE</div>
            <span className="live-chip">LIVE</span>
          </div>
          <div className="stat-value">120</div>
          <div className="progress-row"><MiniBar pct={80.2} /><span className="sc-pct-label">20.2%</span></div>
        </div>

        <div className="stat-card">
          <div className="sc-top-row">
            <div className="stat-label">AVAIL. CAR SPOTS</div>
            <div className="card-vehicle-icon"><img src={CarIconImage} alt="Car" className="custom-car-icon" /></div>
          </div>
          <div className="stat-value">30</div>
          <div className="progress-row"><MiniBar pct={34.8} /><span className="sc-pct-label">34.8%</span></div>
        </div>

        <div className="stat-card">
          <div className="sc-top-row">
            <div className="stat-label">AVAIL. BIKE SPOTS</div>
            <div className="card-vehicle-icon"><img src={BikeIconImage} alt="Bike" className="custom-bike-icon" /></div>
          </div>
          <div className="stat-value">90</div>
          <div className="progress-row"><MiniBar pct={75} /><span className="sc-pct-label">75%</span></div>
        </div>

        <div className="stat-card revenue-card">
          <div className="rev-top-row">
            <div className="rev-left">
              <div className="rev-logo-wrap"><img src={RevenueLogo} alt="Revenue" className="rev-logo" /></div>
              <div className="rev-content">
                <div className="stat-label">Avg. Daily Revenue</div>
                <div className="rev-amount">₹8,420.00</div>
              </div>
            </div>
          </div>
          <div className="rev-divider" />
          <div className="rev-bottom-row">
            <div className="rev-logo-wrap"><img src={TargetLogo} alt="Target" className="rev-logo" /></div>
            <div>
              <div className="stat-label" style={{marginBottom:2}}>Monthly Target</div>
              <div className="rev-reach"><strong>92.4%</strong> Reach</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ── CAPACITY BAR ──────────────────────────────────────────────────────────────

function CapacityBar() {
  const [width, setWidth] = useState(0);
  useEffect(() => { const t = setTimeout(() => setWidth(75), 350); return () => clearTimeout(t); }, []);
  return (
    <div className="capacity-section">
      <div className="cap-header">
        <h2 className="section-title">Parking Capacity</h2>
        <div className="cap-total-label">TOTAL SLOTS: 160</div>
      </div>
      <div className="cap-track">
        <div className="cap-fill" style={{ width: `${width}%` }}>
          <span className="cap-fill-text"><strong>120</strong>&nbsp;AVAILABLE</span>
        </div>
        <div className="cap-occupied-label">
          <strong>40</strong>&nbsp;<span className="cap-occ-word">OCCUPIED</span>
        </div>
      </div>
    </div>
  );
}

function SectionLabel({ children }) {
  return <h2 className="section-title two-col-label">{children}</h2>;
}

// ── TARGET CARD ───────────────────────────────────────────────────────────────

function TargetCard() {
  return (
    <div className="target-wrapper">
      <SectionLabel>Estimated Target</SectionLabel>
      <div className="target-card">
        <img src={TargetBgImage} alt="" className="target-bg-image" />
        <div className="target-label">MONTHLY TARGET</div>
        <div className="target-pct">92.4% <span>Reach</span></div>
        <div className="target-spacer" />
        <div className="target-amount">₹142.8k</div>
        <div className="target-growth">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="2">
            <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/>
            <polyline points="16 7 22 7 22 13"/>
          </svg>
          +12.5% vs last month
        </div>
      </div>
    </div>
  );
}

// ── REVENUE CHART ─────────────────────────────────────────────────────────────

function RevenueChart() {
  const [tab, setTab] = useState("daily");
  const [activeBar, setActiveBar] = useState(4);
  const data = CHART_DATA[tab];
  const handleTab = (key) => { setTab(key); setActiveBar(key==="daily"?4:0); };
  return (
    <div className="overview-wrapper">
      <SectionLabel>Overview</SectionLabel>
      <div className="overview-card">
        <div className="overview-header">
          <div>
            <div className="overview-eyebrow">WEEKLY PERFORMANCE</div>
            <div className="overview-subtitle">Revenue Trends</div>
          </div>
          <div className="tab-group">
            {["daily","weekly","monthly"].map(t=>(
              <div key={t} className={`tab${tab===t?" active":""}`} onClick={()=>handleTab(t)}>
                {t.charAt(0).toUpperCase()+t.slice(1)}
              </div>
            ))}
          </div>
        </div>
        <div className="chart-wrap">
          <div className="chart-y-axis">
            {["100%","80%","60%","40%","20%","0"].map(l=>(
              <span key={l} className="chart-y-label">{l}</span>
            ))}
          </div>
          <div className="chart-bars-area">
            <div className="chart-grid-lines">
              {[0,1,2,3,4,5].map(i=>(<div key={i} className="chart-h-line" />))}
            </div>
            <div className="chart-bars">
              {data.map((d,i)=>(
                <div className="bar-col" key={`${tab}-${i}`}>
                  <div className="bar-wrap">
                    <div
                      className={`bar ${i===activeBar?"bar--active":"bar--inactive"}`}
                      style={{ height:`${d.val}%`, animationDelay:`${0.4+i*0.06}s` }}
                      onClick={()=>setActiveBar(i)}
                    />
                  </div>
                  <div className="bar-label">{d.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── ACTIVITY FEED ─────────────────────────────────────────────────────────────

/* Icon map matching screenshot — purple gradient circles with white arrow/coin icons */
const ACT_ICONS = {
  in:  (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2">
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
      <polyline points="10 17 15 12 10 7"/>
      <line x1="15" y1="12" x2="3" y2="12"/>
    </svg>
  ),
  pay: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2">
      <rect x="2" y="5" width="20" height="14" rx="2"/>
      <line x1="2" y1="10" x2="22" y2="10"/>
    </svg>
  ),
  out: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
      <polyline points="16 17 21 12 16 7"/>
      <line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  ),
};

function ActivityFeed() {
  return (
    <div className="activity-card">
      <div className="card-meta">TODAY ACTIVITY</div>
      <div className="card-heading">Recent Activity</div>
      <div className="activity-list">
        {ACTIVITY.map((a,i)=>(
          <div className="activity-item" key={i}>
            <div className={`act-icon act-icon--${a.type}`}>
              {ACT_ICONS[a.type]}
            </div>
            <div className="act-body">
              <div className="act-title">{a.title}</div>
              <div className="act-sub">{a.sub}</div>
            </div>
            <div className="act-time">{a.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── DONUT CHART ───────────────────────────────────────────────────────────────

function DonutChart() {
  const r = 52, circ = 2 * Math.PI * r; // larger donut
  const bikesPct = 0.481;
  const carsPct  = 0.519; // cars fill the rest (grey)

  return (
    <div className="donut-card">
      <div className="card-meta">TODAY CAPACITY</div>
      <div className="card-heading">Vehicle Wise Distribution</div>
      <div className="donut-body">
        <div className="donut-svg-wrap">
          {/* Outer donut, bigger */}
          <svg width="240" height="220" viewBox="0 0 160 160">
            {/* Grey (cars) base arc */}
            <circle
              cx="80" cy="80" r={r}
              fill="none" stroke="#787878" strokeWidth="26"
            />
            {/* Blue (bikes) arc on top */}
            <circle
              cx="80" cy="80" r={r}
              fill="none" stroke="#3D5BB3" strokeWidth="26"
              strokeDasharray={`${circ * bikesPct} ${circ * carsPct}`}
              strokeDashoffset={circ * 0.25}
              transform="rotate(-90 80 80)"
              strokeLinecap="butt"
            />
          </svg>
        </div>
        {/* Legend below the donut */}
        <div className="donut-legend">
          <div className="legend-item">
            <span className="legend-dot" style={{background:"#3D5BB3"}} />
            <span className="legend-name">Bikes</span>
            <span className="legend-val">48.1%</span>
          </div>
          <div className="legend-item">
            <span className="legend-dot" style={{background:"#787878"}} />
            <span className="legend-name">Cars</span>
            <span className="legend-val">52.9%</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── FLOOR DISTRIBUTION ────────────────────────────────────────────────────────

function FloorDistribution() {
  return (
    <div className="floor-card">
      <div className="card-meta">TODAY CAPACITY</div>
      <div className="card-heading">Floor Wise Distribution</div>
      <div className="floor-grid">
        {FLOORS.map(f => (
          <div className="floor-item" key={f.name}>
            <div className="floor-item-label">{f.label}</div>
            <div className="floor-item-row">
              <div className="floor-count-big">
                {String(f.count).padStart(2,"0")}/{f.total}
              </div>
              <div className="floor-pct-badge" style={{color: f.color === "#D1D5DB" ? "#9CA3AF" : f.color}}>
                {f.pct}%
              </div>
            </div>
            <div className="floor-bar-track">
              <div className="floor-bar-fill" style={{width:`${f.pct}%`, background: f.color}} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── ROOT ──────────────────────────────────────────────────────────────────────

export default function Dashboard({ setPage }) {
  return (
    <div className="pd-root">
      <Sidebar setPage={setPage} />
      <main className="main">
        <Topbar />
        <DailyStats />
        <CapacityBar />
        <div className="two-col">
          <TargetCard />
          <RevenueChart />
        </div>
        <div className="bottom-row">
          <ActivityFeed />
          <DonutChart />
          <FloorDistribution />
        </div>
      </main>
    </div>
  );
}